import { render, staticRenderFns } from "./gradeAdvanceSetting.vue?vue&type=template&id=5e060c05&scoped=true&"
import script from "./gradeAdvanceSetting.vue?vue&type=script&lang=ts&"
export * from "./gradeAdvanceSetting.vue?vue&type=script&lang=ts&"
import style0 from "./gradeAdvanceSetting.vue?vue&type=style&index=0&id=5e060c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e060c05",
  null
  
)

export default component.exports